import api from '@api/apiServices';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { emailDesignQueryOptions } from '@utils/queryOptions';
import EditEmailDesign from '@Views/Emails/designs/edit-design';

export const Route = createFileRoute('/emails/designs/$designId')({
    component: EditEmailDesign,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailDesignQueryOptions(opts.params.designId),
        ),
    beforeLoad: data => {
        if (data.params.designId === 'new') {
            return data.context.queryClient.fetchQuery({
                queryKey: ['newEmailDesign', Math.random()],
                queryFn: () =>
                    api.emails.designs
                        .postForm({ title: 'New Email Design' })
                        .then(res => redirect({ to: `../${res.id}` })),
            });
        }
    },
});
